import { Badge, BadgeTypes } from '../../Badge';
import { Spinner } from '../../Spinner';

interface OptionsStatusProps {
  isLoading: boolean;
  error?: string | Error | null;
}

export function OptionsStatus({ isLoading, error }: OptionsStatusProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-2">
        <Spinner className="text-fiona h-5 w-5" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-3">
        <Badge
          type={BadgeTypes.DANGER}
          showIcon
          label="Error"
          text={typeof error === 'string' ? error : error.message || 'Error fetching options'}
          className="w-full text-wrap"
        />
      </div>
    );
  }

  return null;
}
